import styled, { css } from "styled-components";
import { rgba } from "polished";
import { color, onHover, units } from "@m/alchemy-theme";
import { Button } from "../button/Button.styled";
import { MenuButton } from "../menu-button/MenuButton.styled";
import { ToggleButton } from "../form/toggle-button/ToggleButton.styled";
export const ButtonGroup = styled.div `
  display: flex;
  flex-wrap: wrap;

  ${MenuButton}, ${Button}, ${ToggleButton} {
    flex-grow: ${({ isDistributed }) => (isDistributed ? 1 : 0)};
    margin-right: ${({ isDistributed }) => (isDistributed ? units(1) : 0)};
    margin-bottom: ${({ attachedTo }) => (attachedTo ? 0 : units(0.5))};
    max-width: 100%;
    white-space: normal;

    ${(props) => !props.hasSingleChild &&
    css `
        z-index: 0;

        ${onHover(css `
          z-index: 1;
        `)}

        ${props.isJoined
        ? css `
              border-color: ${props.activeColorScheme === "alchemyBrand" ? rgba(color("inverse")(props), 0.2) : "none"};
              &:not(:last-child) {
                margin-right: -1px;
              }

              &:not(:first-child):not(:last-child) {
                border-radius: 0;
              }

              &:first-child {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
              }

              &:last-child {
                margin-right: 0;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
              }
            `
        : css `
              &:not(:last-child) {
                margin-right: ${units(1)};
              }
            `};
      `};

    ${({ attachedTo }) => attachedTo &&
    css `
        border-radius: 0;

        &:first-child {
          border-left-width: 0;
        }

        &:last-child {
          border-right-width: 0;
        }

        ${attachedTo === "bottom" &&
        css `
          border-bottom-width: 0;
        `};

        ${attachedTo === "top" &&
        css `
          border-top-width: 0;
        `};
      `};
  }
`;
